import React, { useState, useEffect } from 'react';
import { TextField, Chip, Autocomplete, Box, Button } from '@mui/material';
import { USERID } from "../config/constants";
import { getUsersList, getSharedUsersList } from '../services/expediente.service';

const SelectorDeUsuarioParaCompartir = ({ callback, setIsVisibleModal, setReload, reload, id_expediente }) => {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [users, setUsersList] = useState([]);
  const currentUserid = localStorage.getItem(USERID);

  const handleSelectionChange = (event, newValue) => {
    setSelectedUsers(newValue);
  };

  const handleDelete = (userToDelete) => {
    setSelectedUsers((prevUsers) =>
      prevUsers.filter((user) => user.mail !== userToDelete.mail)
    );
  };

  const onClose = () => {
    setIsVisibleModal(false);
    setReload(!reload);
  };

  const saveSelection = () => {
    callback(selectedUsers, id_expediente);
    setIsVisibleModal(false);
  };

  useEffect(() => {
    async function fetchUsers() {
      const usersResponse = await getUsersList(currentUserid);
      setUsersList(usersResponse.data);

      // Mapeamos los usuarios compartidos para coincidir con las opciones de la lista de usuarios
      const sharedResponse = await getSharedUsersList(id_expediente);
      const sharedUsers = sharedResponse.data.map((sharedUser) =>
        usersResponse.data.find((user) => user.mail === sharedUser.mail)
      ).filter(Boolean);  // Eliminamos usuarios no encontrados

      setSelectedUsers(sharedUsers);
    }

    fetchUsers();
  }, [id_expediente, currentUserid]);

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <Autocomplete
        multiple
        id="user-share-selector"
        options={users}
        size="small"
        getOptionLabel={(option) => `${option.nombre} (${option.mail})`}
        value={selectedUsers}
        onChange={handleSelectionChange}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Seleccionar usuarios"
            placeholder="Buscar por email o nombre"
          />
        )}
        renderTags={() => null}  
      />
      <Box sx={{ marginTop: 2, display: 'flex', flexWrap: 'wrap' }}>
        {selectedUsers.map((user) => (
          <Chip
            key={user.mail}
            label={`${user.nombre} (${user.mail})`}
            onDelete={() => handleDelete(user)}
            sx={{ margin: 0.5 }}
          />
        ))}
      </Box>
      <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={onClose} variant="outlined" sx={{ marginRight: 1 }}>
          CANCELAR
        </Button>
        <Button onClick={saveSelection} variant="contained">
          COMPARTIR
        </Button>
      </Box>
    </Box>
  );
};

export default SelectorDeUsuarioParaCompartir;
